import React, {Component} from 'react';
import { connect } from "react-redux";
import axios from "axios";
import FormTemplate from "../common/form/FormTemplate";
import { setSelectedControlPanelType, IncomingEventPurgeScheduleControlPanelKey } from "../../redux/actions/controlPanelActions";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';
import { LOADING_STATUES } from "../constants/constants";

const componentName = IncomingEventPurgeScheduleControlPanelKey;

const matchDispatchToProps = (dispatch) => {
  return { 
    setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName))
  }
}

class IncomingEventPurgeSchedule extends Component {

  state = {
    automaticPurge: false,
    automaticPurgeAfterDays: "0",
    status: ""
  }

  handleSubmit = (event) => {
    event.preventDefault();
    
    if (this.state.status === "") {
      this.setState({
        status: LOADING_STATUES.LOADING
      })
    } else {
      return;
    }

    axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/countyConfig/incomingEventPurgeSchedule", this.state, { withCredentials: true })
    .then(
      (response) => {
        this.setState({ 
          status: LOADING_STATUES.SUCCESS
        });
      },
      (error) => {
        handleError(error, this.props.history);
      }
    );
  }

  handleChange = (event) => {
    let value = event.target.value;
    value = value === "true" || value === "false" ? JSON.parse(event.target.value) : value;

    this.setState({
      status: "",
      [event.target.id]: value ? value : (event.target.type === 'number' ? 0 : value)
    })
  }

	componentDidMount() {
    this.props.setSelectedControlPanelType();

    axios.get(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/countyConfig/incomingEventPurgeSchedule", { withCredentials: true })
    .then(
      (response) => {
        const content = response.data.content;
        this.setState( {
          automaticPurge: content.automaticPurge,
          automaticPurgeAfterDays: content.automaticPurgeAfterDays,
          status : ""
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  render() {
    const formProps = {
      componentName: componentName,
      pageHeading: "Incoming Event Purge Schedule",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      successIndicator: this.state.status === LOADING_STATUES.SUCCESS,
      loadingIndicator: this.state.status === LOADING_STATUES.LOADING,
      formGroupRows: [
        {
          formGroups: [{ id: 'automaticPurge', label: 'Automatic purge', fieldType: 'select', value: this.state.automaticPurge, style: {maxWidth: 200} }]
        },
        {
          formGroups: [{ id: 'automaticPurgeAfterDays', label: 'After processed days ago', fieldType: 'number', minValue: 7, disableField: this.state.automaticPurge === false, value: this.state.automaticPurgeAfterDays, style: {maxWidth: 200}  }]
        }
      ]
    }

    return <FormTemplate {...formProps} />
  }
}

export default connect(null, matchDispatchToProps)(IncomingEventPurgeSchedule);